const request = require("request")
/* globals localStorage */

export default {
    login(email, pass, system, additional_data, cb) {
        cb = arguments[arguments.length - 1]
        // if (localStorage.token) {
        //   if (cb) cb(true)
        //   this.onChange(true)
        //   return
        // }
        checkUser(email, pass, system, additional_data, (res) => {
            if (res.userfound) {
                if (res.active) {
                    if (res.twofactor_required) {
                        if (cb) cb({ userfound: true, active: true, verification: true, twofactor_required: true, challenge_id: res.challenge_id, mail_hint: res.mail_hint })
                        return
                    }
                    if (res.authenticated) {
                        // //console.log(res.id)
                        if (res.verification) {
                            storeSession(res)
                            if (cb) cb({ authentication: true, verification: true, userfound: true, active: true })
                            this.onChange(true)
                        } else {
                            if (cb) cb({ authentication: true, verification: false, userfound: true, active: true })
                            this.onChange(true)
                        }
                    } else {
                        if (res.verification) {
                            if (cb) cb({ authentication: false, verification: true, userfound: true, active: true })
                            this.onChange(true)
                        } else {
                            if (cb) cb({ authentication: false, verification: false, userfound: true, active: true })
                            this.onChange(true)
                        }
                    }
                } else {
                    if (cb) cb({ userfound: true, active: false })
                    this.onChange(true)
                }
            } else {
                if (cb) cb({ userfound: false })
                this.onChange(true)
            }
        })
    },

    // Zweiter Schritt nach login(), wenn twofactor_required zurueckkam. Bei Erfolg speichert es die
    // Session genau wie login() und liefert dieselbe { authentication: true }-Form.
    verifyTwoFactor(challenge_id, code, remember_device, cb) {
        var obj = {
            method: "POST",
            headers: {
                Authorization: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
                Accept: "application/json",
                "Content-Type": "application/json",
                Origin: "localhost",
                Host: "localhost"
            },
            body: JSON.stringify({ challenge_id: challenge_id, code: code, remember_device: !!remember_device })
        }

        fetch(process.env.VUE_APP_APIURL + "/user/login/2fa/verify", obj)
            .then((response) => response.json().then((data) => ({ status: response.status, data: data })))
            .then(({ status, data }) => {
                if (status == 200 && data.login == true) {
                    storeSession(data)
                    if (cb) cb({ authentication: true, mail: data.mail })
                    this.onChange(true)
                } else {
                    if (cb) cb({ authentication: false, twofactor_error: data.twofactor_error, attempts_left: data.attempts_left })
                }
            })
            .catch(() => {
                if (cb) cb({ authentication: false, error: true })
            })
    },

    resendTwoFactor(challenge_id, cb) {
        var obj = {
            method: "POST",
            headers: {
                Authorization: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
                Accept: "application/json",
                "Content-Type": "application/json",
                Origin: "localhost",
                Host: "localhost"
            },
            body: JSON.stringify({ challenge_id: challenge_id })
        }

        fetch(process.env.VUE_APP_APIURL + "/user/login/2fa/resend", obj)
            .then((response) => response.json().then((data) => ({ status: response.status, data: data })))
            .then(({ status, data }) => {
                if (cb) cb({ sent: status == 200 && data.sent, twofactor_error: data.twofactor_error, retry_after: data.retry_after })
            })
            .catch(() => {
                if (cb) cb({ sent: false, error: true })
            })
    },

    // Google (und spaeter weitere Provider) - credential ist das vom Provider signierte ID-Token, das
    // Backend verifiziert es serverseitig (siehe searchinsights-api /user/login/oauth). Erfolgreicher
    // OAuth-Login gilt selbst als zweiter Faktor, es folgt kein zusaetzlicher E-Mail-Code-Schritt.
    oauthLogin(provider, credential, cb) {
        var obj = {
            method: "POST",
            headers: {
                Authorization: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
                Accept: "application/json",
                "Content-Type": "application/json",
                Origin: "localhost",
                Host: "localhost"
            },
            body: JSON.stringify({ provider: provider, credential: credential })
        }

        fetch(process.env.VUE_APP_APIURL + "/user/login/oauth", obj)
            .then((response) => response.json().then((data) => ({ status: response.status, data: data })))
            .then(({ status, data }) => {
                if (status == 200 && data.login == true) {
                    storeSession(data)
                    if (cb) cb({ authentication: true, mail: data.mail, registered: !!data.registered })
                    this.onChange(true)
                } else {
                    if (cb) cb({ authentication: false, oauth_error: data.oauth_error, singleusererror: !!data.singleusererror })
                }
            })
            .catch(() => {
                if (cb) cb({ authentication: false, error: true })
            })
    },

    getToken() {
        return localStorage.token
    },

    logout(cb) {
        delete localStorage.token
        delete localStorage.user
        delete localStorage.id
        delete localStorage.company_id
        delete localStorage.plan
        delete localStorage.username
        // device_token bleibt bewusst erhalten - "Geraet fuer 7 Tage merken" soll einen Logout
        // ueberleben, sonst muesste man nach jedem Logout den 2FA-Code erneut eingeben.
        if (cb) cb()
        this.onChange(false)
    },

    ssoAuth(sso_token) {
        // //console.log(localStorage.token)
        var obj = {
            method: "POST",
            headers: {
                Authorization: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
                Accept: "application/json",
                "Content-Type": "application/json",
                Origin: "localhost",
                Host: "localhost"
            },
            body: JSON.stringify({
                sso_token: sso_token
            })
        }

        return fetch(process.env.VUE_APP_APIURL + "/user/login/sso", obj)
            .then((response) => response.json())
            .then((responseData) => {
                // console.log(responseData)

                if (responseData) {
                    localStorage.token = responseData.token
                    localStorage.user = responseData.user
                    localStorage.id = responseData.id
                    localStorage.company_id = responseData.company_id
                    localStorage.plan = responseData.plan
                    localStorage.username = responseData.username
                    console.log("SSO Token found, logging in")
                    return responseData
                } else {
                    console.log("Invalid SSO Token")
                    delete localStorage.token
                    delete localStorage.user
                    delete localStorage.id
                    delete localStorage.company_id
                    delete localStorage.plan
                    delete localStorage.username
                    return false
                }
            })
            .catch((error) => console.log(error))
    },

    loggedIn() {
        // //console.log(localStorage.token)
        var obj = {
            method: "POST",
            headers: {
                Authorization: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
                Accept: "application/json",
                "Content-Type": "application/json",
                Origin: "localhost",
                Host: "localhost"
            },
            body: JSON.stringify({
                user: localStorage.user,
                token: localStorage.token
            })
        }

        return fetch(process.env.VUE_APP_APIURL + "/user/tokencheck", obj)
            .then((response) => response.json())
            .then((responseData) => {
                // //console.log(responseData.token, localStorage.token)
                console.log(responseData)
                if (responseData.loggedIn) {
                    console.log("Valid Token")
                    return true
                } else {
                    console.log("Invalid Token")
                    return false
                }
            })
            .catch((error) => {
                console.log("LOGIN ERROR")
                console.log(error)
                return { no_redirect: true }
                // if (error == "TypeError: NetworkError when attempting to fetch resource.") return true
            })
    },
    apiOnline() {
        // //console.log(localStorage.token)
        var obj = {
            method: "GET",
            headers: {
                Authorization: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
                Accept: "application/json",
                "Content-Type": "application/json",
                Origin: "localhost",
                Host: "localhost"
            }
            // body: JSON.stringify({
            //     user: localStorage.user,
            //     token: localStorage.token
            // })
        }

        return fetch("http://localhost:3010/status" + "/quaro/api", obj)
            .then((response) => response.json())
            .then((responseData) => {
                console.log("RESPONSE:", responseData)

                if (responseData.api_online) {
                    return true
                } else {
                    return false
                }
            })
            .catch((error) => console.log("RESPONSE ERROR:", error))
    },
    onChange() {}
}

// Gemeinsame Ablage der 6 Session-Keys (vorher an 2 Stellen inline dupliziert) plus optional dem
// Trusted-Device-Token, wenn "Geraet merken" beim 2FA-Code angehakt war.
function storeSession(data) {
    localStorage.token = data.token
    localStorage.user = data.mail
    localStorage.id = data.id
    localStorage.company_id = data.company_id
    localStorage.plan = data.plan
    localStorage.username = data.username
    if (data.device_token) {
        localStorage.device_token = data.device_token
        if (data.device_token_expires_at) localStorage.device_token_expires_at = data.device_token_expires_at
    }
}

function checkUser(email, pass, system, additional_data, cb) {
    var obj = {
        method: "POST",
        headers: {
            Authorization: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "localhost",
            Host: "localhost"
        },
        body: JSON.stringify({
            email: email,
            pass: pass,
            system: system,
            additional_data: additional_data,
            device_token: localStorage.device_token || null
        })
    }

    fetch(process.env.VUE_APP_APIURL + "/user/login", obj)
        .then(function (response) {
            return response.json()
        })
        .then(function (data) {
            // console.log(data);
            if (data.twofactor_required) {
                cb({ userfound: true, active: true, twofactor_required: true, challenge_id: data.challenge_id, mail_hint: data.mail_hint })
            } else if (!data.nousererror) {
                if (!data.inactiverror) {
                    if (!data.verificationerror) {
                        if (data.login == true) {
                            cb({
                                userfound: true,
                                active: true,
                                authenticated: true,
                                token: data.token,
                                id: data.id,
                                company_id: data.company_id,
                                verification: true,
                                plan: data.plan,
                                username: data.username,
                                mail: data.mail
                            })
                        } else {
                            cb({ authenticated: false, verification: true, userfound: true, active: true })
                        }
                    } else {
                        //console.log("verification error")
                        cb({ authenticated: true, verification: false, userfound: true, active: true })
                    }
                } else {
                    cb({ userfound: true, active: false })
                }
            } else {
                cb({ userfound: false })
            }
        })
        .catch(function () {
            //console.log("Fehler beim Usercheck");
            // Ohne cb() haengt der Aufrufer (Login.vue) im Spinner fest - vorher wurde ein
            // Netzwerkfehler hier stillschweigend verschluckt.
            cb({ userfound: false, error: true })
        })
}
